import { Box, Button, Grid, Tab, Tabs, Typography } from "@mui/material";
import { MetricsContext, Tier } from "contexts/Metrics";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect, useState } from "react";
import { Plans } from "schemas/payments";

import styles from "./styles";

const MetricsByTier = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const { subscription, setUpgradeDialogSource } =
    useContext(SubscriptionContext);
  const { tierStats, fetchMetricsByTier } = useContext(MetricsContext);

  const [tab, setTab] = useState(Tier.free);
  const [upgradeLink, setUpgradeLink] = useState<Tier | null>(null);

  const getCurrentTier = () => {
    const planName =
      subscription?.subscription?.planName || subscription?.overridePlanName;
    if (planName === Plans.PRO || planName === Plans.PRO_YEARLY) {
      setUpgradeLink(Tier.va);
      return Tier.pro;
    } else if (planName === Plans.VA || planName === Plans.VA_YEARLY) {
      setUpgradeLink(null);
      return Tier.va;
    }
    setUpgradeLink(Tier.pro);
    return Tier.free;
  };

  useEffect(() => {
    if (currentOrg?.id) {
      fetchMetricsByTier(tab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id, tab]);

  useEffect(() => {
    const currentTier = getCurrentTier();
    setTab(currentTier);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrg?.id]);

  const onChange = (event: React.SyntheticEvent, newValue: Tier) => {
    setTab(newValue);
  };

  const showAsPercentage = (value: number) => {
    return `${(value || 0).toFixed(0)}`;
  };

  return (
    <Box sx={styles.metricsWrapper}>
      <Typography sx={styles.header}>How your peers are doing</Typography>

      <Tabs sx={styles.tabs} value={tab} onChange={onChange}>
        <Tab sx={styles.tab} value={Tier.free} label="Free" />
        <Tab sx={styles.tab} value={Tier.pro} label="Pro" />
        <Tab sx={styles.tab} value={Tier.va} label="VA" />
      </Tabs>

      <Box sx={{ mt: 2 }}>
        <Typography sx={{ fontSize: 12 }} textAlign="center">
          {showAsPercentage(tierStats?.outreachCount || 0)} Avg. Emails Sent
          This Week
        </Typography>
        <Grid item xs={12} container justifyContent="center">
          {tab === upgradeLink && (
            <Button
              size="small"
              sx={{ mt: 1, fontSize: 12 }}
              onClick={() => {
                setUpgradeDialogSource("Upgrade from Tier Metrics");
              }}
            >
              Upgrade ✨
            </Button>
          )}
        </Grid>
      </Box>
    </Box>
  );
};

export default MetricsByTier;
